module.exports = __webpack_public_path__ + "static/media/19ESCAP27.001654be.jpg";